import {State} from '../types/state'

export const isRequestPending = (state: State, requestName: string) =>
  Boolean(state.pendingRequests.requestNames.find(name => name === requestName))

export const isCheckoutActionPending = (state: State): boolean => {
  const updateOrderInProgress = isRequestPending(state, 'UPDATE_ORDER_REQUEST')
  const placeOrderInProgress = isRequestPending(state, 'PLACE_ORDER_REQUEST')
  const reserveTicketsInProgress = isRequestPending(state, 'RESERVE_TICKETS_REQUEST')
  const navigateInProgress = isRequestPending(state, 'NAVIGATE')

  return updateOrderInProgress || placeOrderInProgress || reserveTicketsInProgress || navigateInProgress
}
